import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '@app/core/startup';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Acceptance194RService } from './acceptance194-r.service';

@Component({
    selector: 'app-acceptance194-r',
    templateUrl: './acceptance194-r.component.html',
    styleUrls: ['./acceptance194-r.component.scss']
})
export class Acceptance194RComponent implements OnInit {
    @ViewChild('content', { static: true }) content: ElementRef;


    constructor(
        private modalService: NgbModal,
        private authService: AuthenticationService,
        private acceptance194RService: Acceptance194RService,
        config: NgbModalConfig
    ) {
        config.backdrop = 'static';
        config.keyboard = false;
    }

    cookieValue: any;
    expiredDate: any;

    registerDate: any;
    updateDate: any;

    getIds: object;

    ngOnInit(): void {
        if (localStorage.getItem("token")){
            this.acceptance194RService.getUserTdsAcceptance().subscribe((response) => {
                if (localStorage.getItem("token") && !response) {
                    this.modalService.open(this.content, { centered: true });
                    this.expiredDate = new Date();
                }
            });
        }
    }
    logout() {
        let tdsAppectance = {
            status: false
        };
        this.acceptance194RService.updateUserTdsAcceptanceStatus(tdsAppectance).subscribe((res) => {
            this.authService.logout();
            this.modalService.dismissAll();
        }, (err) => {
            this.authService.logout();
        });
    }

    acceptance() {
        let tdsAppectance = {
            status: true
        };
        this.acceptance194RService.updateUserTdsAcceptanceStatus(tdsAppectance).subscribe((res) => {
            this.modalService.dismissAll();
        }, (err) => {
            console.log(err);
        });
    }

}
